import React from 'react';
import PropTypes from 'prop-types';


import { Typo, Paragraph } from '@ers/ui/';
import { Section, Clause, Consent } from '..';

const ClausesAndConsents = ({ form, translations }) => (
    <>
        <Section.Conditional
            condition={Boolean(form.clauses.length)}
            title={translations.clauses}
        >
            {() => (
                <div className="clauses">
                    {form.clauses.map((clause) => (
                        <Clause key={`clause_${clause.id}`}>
                            <Paragraph>{clause.content}</Paragraph>
                        </Clause>
                    ))}

                </div>
            )}
        </Section.Conditional>
        <Section.Conditional
            condition={Boolean(form.consents.length)}
            title={translations.consents}
        >
            {() => (
                <div className="consents">
                    {form.consents.map(({ id, isChecked, content }) => (
                        <Consent key={`consent_${id}`} accepted={isChecked}>
                            <Typo.Body variant={Typo.Variants.DARK}>{content}</Typo.Body>
                        </Consent>
                    ))}
                </div>
            )}
        </Section.Conditional>
    </>
);
ClausesAndConsents.propTypes = {
    form: PropTypes.object.isRequired,
    translations: PropTypes.object.isRequired
};

export default ClausesAndConsents;
